export const AppConfig = {
  site_name: 'DessertData',
  title: 'Dessert Data',
  company: 'Dessert Data',
  description: 'A love for ingesting data',
  locale: 'en',
  domain: 'dessertdata.com',
  email: 'hello@dessertdata.com',
};
